import { LiveInterval } from '@/rxdb/constants';

import {
  BorerOperatorState,
  borerOperatorStatePullQueryBuilder,
} from '../../BorerOperatorStateFeed/queryBuilder';
import { create } from '../FamilyMember/create';
import { FamilyMember } from '../FamilyMember/FamilyMember';
import { ConfigBuilder, pull, replicate, ReplicationState, schedule } from '../replicate';
import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';
import { pullModifier } from './pullModifier';

export function createReplicationState(
  configBuilder: ConfigBuilder,
): ReplicationState<BorerOperatorState> {
  const syncConfig = configBuilder<BorerOperatorState>(
    RxdbCollectionNameV2.BORER_OPERATOR_STATE_FEED,
  );
  const pullConfig = pull(syncConfig, borerOperatorStatePullQueryBuilder);
  pullConfig.modifier = pullModifier;

  // Note that BORER_OPERATOR_STATE_FEED does *not* have a push query.

  const replicationState = replicate(syncConfig);
  return replicationState;
}

export function replicateBorerOperatorState(
  configBuilder: ConfigBuilder,
  syncStates: ReplicationState<unknown>[],
  reSyncTimeouts: NodeJS.Timeout[],
): ReplicationState<BorerOperatorState> {
  const replicationState = createReplicationState(configBuilder);
  syncStates.push(replicationState as ReplicationState<unknown>);

  const reSyncInterval = schedule(replicationState, LiveInterval.SECONDS_15);
  reSyncTimeouts.push(reSyncInterval);

  return replicationState;
}

export function borerOperatorStateFeedFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember,
  borerShiftAdvance: FamilyMember,
  borerStateType: FamilyMember,
  cuttingMethod: FamilyMember,
  cuttingType: FamilyMember,
  equipment: FamilyMember,
): FamilyMember<BorerOperatorState> {
  const replicationState = createReplicationState(configBuilder);
  return create(RxdbCollectionNameV2.BORER_OPERATOR_STATE_FEED, replicationState, [
    borerShift,
    borerShiftAdvance,
    borerStateType,
    cuttingMethod,
    cuttingType,
    equipment,
  ]);
}
